import { render } from "./CreatePrescripcionDispositivos.vue?vue&type=template&id=e9d3a144&scoped=true"
import script from "./CreatePrescripcionDispositivos.vue?vue&type=script&lang=js"
export * from "./CreatePrescripcionDispositivos.vue?vue&type=script&lang=js"

import "./CreatePrescripcionDispositivos.vue?vue&type=style&index=0&id=e9d3a144&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9d3a144"]])

export default __exports__